




























































import Vue from 'vue'
import Component from 'vue-class-component'
import { Mutation, State, Getter } from 'vuex-class';
import LocaleSelectComponent from '@/modules/i18n/components/LocaleSelect.vue'
import Locale from '@/modules/i18n/model/Locale'
import { Page } from '@/modules/cms/types'

/**
 * Selección de traducción
 *
 * Componente mostrado en la pantalla de edición de una publicación del blog,
 * permite seleccionar la traducción a editar y añadir una nueva
 * seleccionando uno de los localismos registrados en la
 * aplicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        'locale-select': LocaleSelectComponent,
    },
})
export default class PageTranslationSelector extends Vue {

    /**
     * Cambia la traducción que actualmente esta editando la pantalla de edición
     * de la página
     */
    @Mutation('cms/page/current/translation/set-by-locale')
    public setCurrentTranslation: (locale: string) => void

    /**
     * Permite obtener el nombre de un localismo en base a su identificador
     *
     * @return { string } Nombre del localismo
     */
    @Getter('i18n/worldLocaleName')
    public worldLocaleName: (locale: string) => string

    /**
     * Traducción actual
     *
     * Propiedad que almacena el localismo de la la traducción actualmente en
     * edición
     */
    get currentTranslation () {
        return this.$store.state.cms.currentTranslation.locale
    }

    set currentTranslation (value: string) {
        this.setCurrentTranslation(value)
    }

    /**
     * Traducción actual
     */
    @State(state => state.cms.currentPage)
    public page: Page

    /**
     * Indica si el modal para seleccionar un localismo esta abierto o cerrado
     *
     * @type { boolean }
     */
    public localeSelection = false
    public selectedLocale: Locale | null  = null

    /**
     * Filtros para la selección de idiomas
     *
     * Indica al selector de localismos que no incluya en el desplegable de
     * selección los idiomas que ya existen en la publicación.
     */
    get localeSelectFilters (): object {
        return {
            policy: 'exclude',
            identifiers: this.page.translations.map(t => t.locale),
        }
    }

    /**
     * Confirmar selección
     */
    public confirm () {
        this.setCurrentTranslation(this.selectedLocale!.identifier)
        this.selectedLocale = null
        this.localeSelection = false
    }
}
